export default {
    url: 'about-us',
    include: ['us', 'za', 'jp', 'cn', 'ca', 'uk', 'au', 'de', 'fr', 'it', 'es', 'cis', 'sa', 'eu', 'ph'],
};
